import * as utils from "@intrasync/utils";
import { makeAutoObservable } from "mobx";
import { RootStore, ServiceStore } from "@intrasync/stores";

class DispatchStore {
  rootStore: RootStore;
  constructor(rootStore: RootStore) {
    this.rootStore = rootStore;
    makeAutoObservable(this);
  }

  get job() {
    const jobStore = this.rootStore.jobStore as ServiceStore;
    if (!jobStore) return null;
    const { entities } = jobStore;

    return entities.find((job) => {
      return utils.isSameJobNumber(
        job.jobNumber as string | number,
        this.jobNumber
      );
    });
  }

  get jobNumber() {
    const routerStore = this.rootStore.routerStore;
    if (!routerStore) return "";
    const {
      params: { jobNumber },
    } = routerStore;

    return jobNumber as number;
  }

  get loadDates() {
    return utils
      .uniqueArray(this.loadsForCurrentJob.map((l) => l.loadDate as string))
      .sort((a, b) => (a < b ? -1 : 1));
  }

  get loadsForCurrentJob() {
    // console.log('this.jobNumber', this.jobNumber);
    const loadStore = this.rootStore.loadStore as ServiceStore;
    // const trailerStore = this.rootStore.trailerStore as ServiceStore;

    if (!loadStore?.entities?.length) return [];
    // console.log('loadStore.entities', loadStore.entities);

    return loadStore.entities
      .slice()
      .filter((load) => String(load.jobNumber) === String(this.jobNumber));
    //   .filter((load) => {
    //     // if (this.buildingSetting === 1)
    //     //   return parseInt(load.loadNumber) < parseInt(2000);

    //     // return parseInt(load.loadNumber as string) >= parseInt('2000');
    //     return true;
    //   })
    //   .map((load) => {
    //     const trailer = trailerStore.entities.find(
    //       (trailer) => trailer.trailerNumber === load.trailerNumber
    //     );

    //     if (trailer) {
    //       const { ...trailerData } = trailer;
    //       return { ...trailerData, ...load };
    //     }

    //     return { ...load };
    //   });
  }

  get entities() {
    // console.log('loadsForCurrentJob', this.loadsForCurrentJob);
    return this.loadsForCurrentJob;
  }
}

export default DispatchStore;
